import React from "react";
import styles from "./StatusChip.module.css";

/**
 * Maps whatever the backend calls an order's state onto the three the design
 * knows: Active, Activating, Expired.
 *
 * A code's expiry is the customer's activation deadline (activation_status,
 * 30 days from purchase by default), not coupon_code.time_of_expiry. That is
 * the merchant's stock date - often a placeholder - and marked codes expired
 * that still work. The stock date is only a fallback for responses from before
 * the backend sent activation_status.
 */
export const orderState = (order = {}) => {
  const raw = String(order.status || "").toLowerCase();
  if (raw.includes("expir") || raw.includes("cancel") || raw.includes("refund")) return "expired";
  if (order.activation_status === "expired") return "expired";
  const expiry = order.coupon_code?.time_of_expiry;
  if (!order.activation_status && expiry && new Date(expiry) < new Date()) return "expired";
  if (order.is_activation_pending || raw.includes("pending") || raw.includes("process")) return "activating";
  return "active";
};

const LABEL = { active: "Active", activating: "Activating", expired: "Expired" };

export const StatusChip = ({ state = "active", large = false }) => (
  <span className={`${styles.chip} ${styles[state] || styles.active} ${large ? styles.large : ""}`}>
    {LABEL[state] || LABEL.active}
  </span>
);

export default StatusChip;
